import { useEffect, type ReactNode } from 'react';
import { ShareDeviceFooter } from '@/components/elements/ShareDeviceFooter';
import { ShareDeviceHeader } from '@/components/elements/ShareDeviceHeader';

interface ShareDeviceLayoutProps {
  children: ReactNode;
  showBackToTop?: boolean;
  onBackToTop?: () => void;
}

export const ShareDeviceLayout = ({
  children,
  showBackToTop = false,
  onBackToTop,
}: ShareDeviceLayoutProps) => {
  // Add layout class to body on mount
  // 注: クリーンアップでは削除しない（他のページでも必要なため）
  useEffect(() => {
    document.body.classList.add('layout');
  }, []);

  return (
    <div className="wrap">
      <ShareDeviceHeader
        showBackToTop={showBackToTop}
        onBackToTop={onBackToTop}
      />
      {children}
      <ShareDeviceFooter />
    </div>
  );
};
